module.exports = __webpack_public_path__ + "img/Logo_Interreg_Danube.png_ff.270add01.png";